const API_BASE = (process.env.REACT_APP_API_URL || 'https://bibleduo-game-production.up.railway.app').replace(/\/$/, '');

export const generateMnemonic = async () => {
  const res = await fetch(`${API_BASE}/api/auth/generate-mnemonic`);
  const data = await res.json();
  return data.mnemonic;
};

export const validateMnemonic = (phrase) => {
  const words = phrase.toLowerCase().trim().replace(/\s+/g, ' ').split(' ');
  return words.length === 12 && words.every(w => w.length >= 2);
};
